/**
 * firstNameOf — devuelve el primer nombre legible del usuario. ROUND17 #1.
 *
 * Acepta `fullName` típico ("Alejandro Cortés"), o un email fallback
 * ("alejandro@..."). Si nada legible queda → null para que el caller
 * decida si esconde el saludo o muestra un genérico.
 */
export function firstNameOf(input: string | null | undefined): string | null {
  if (!input || !input.trim()) return null;
  const raw = input.trim();
  // Si vino un email, usar la parte local antes de @ y la primera "palabra".
  const localPart = raw.includes('@') ? raw.split('@')[0] : raw;
  const first = localPart.split(/[\s._-]+/).filter(Boolean)[0];
  if (!first) return null;
  // Capitaliza primera letra, conserva el resto como vino (acentos, etc.).
  return first.charAt(0).toUpperCase() + first.slice(1);
}
